/** Klien API notifikasi pengguna. */

import { api } from "./client";

export interface AppNotification {
  id: string;
  type: string;
  title: string;
  body: string | null;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationsResponse {
  notifications: AppNotification[];
  unread: number;
}

export function fetchNotifications(): Promise<NotificationsResponse> {
  return api.get<NotificationsResponse>("/notifications");
}

export function markNotificationRead(id: string): Promise<{ ok: boolean }> {
  return api.post<{ ok: boolean }>(`/notifications/${id}/read`);
}

export function markAllNotificationsRead(): Promise<{ ok: boolean; updated: number }> {
  return api.post<{ ok: boolean; updated: number }>("/notifications/read-all");
}
